import { openCopilotOverlay } from '@/shared/stores/ui';

import type { ICD10CodeT } from '@/entities/labs';
import type { SourceProposedActionT } from '@/shared/lib';

export interface LabOrderWizardPrefill {
  labTestId: string;
  labTestName?: string;
  icdCodes?: ICD10CodeT[];
  notes?: string;
  priority?: boolean;
  sourceProposedAction?: SourceProposedActionT;
}

declare module '@/shared/stores/ui/copilotOverlay' {
  interface CopilotOverlayPayloads {
    labOrderWizard: LabOrderWizardPrefill | null;
  }
}

/**
 * Open the lab order wizard. Pass ``null`` to open it empty for manual entry,
 * or a prefill to seed it from a proposed action.
 */
export function openLabOrderWizardOverlay(prefill: LabOrderWizardPrefill | null): void {
  openCopilotOverlay('labOrderWizard', prefill);
}
